import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatTabsModule } from "@angular/material/tabs";
import { MatInputModule } from "@angular/material/input";
import { FlexLayoutModule, GridModule } from "@angular/flex-layout";
import { MatChipsModule } from "@angular/material/chips";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDividerModule} from '@angular/material/divider';
import { ReplyReviewComponent } from "./reply-review/reply-review.component";
import { SendSmsComponent } from "./send-sms/send-sms.component";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { BreadcrumbsModule } from "src/@vex/components/breadcrumbs/breadcrumbs.module";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTooltipModule } from "@angular/material/tooltip";
import { IconModule } from "@visurel/iconify-angular";
import { SecondaryToolbarModule } from "src/@vex/components/secondary-toolbar/secondary-toolbar.module";
import { ContainerModule } from "src/@vex/directives/container/container.module";
import { LeadHistoryPanelModule } from "../../components/lead-history-panel/lead-history-panel.module";
import { FiltersModule } from "../filters/filters.module";
import { ViewModule } from "../leads/view/view.module";
import { WalkinModule } from "../leads/walkin/walkin.module";


@NgModule({
    declarations: [ReplyReviewComponent,SendSmsComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        BreadcrumbsModule,
        MatPaginatorModule,
        MatTableModule,
        MatSortModule,
        MatCheckboxModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        IconModule,
        FormsModule,
        MatTooltipModule,
        ReactiveFormsModule,
        ContainerModule,
        MatSelectModule,
        MatButtonToggleModule,
        MatInputModule,
        ViewModule,
        WalkinModule,
        GridModule,
        SecondaryToolbarModule,
        MatSidenavModule,
        LeadHistoryPanelModule,
        FiltersModule,
        MatProgressBarModule,
        MatChipsModule,
        MatCardModule,
        MatIconModule,
        MatDividerModule,
        MatDialogModule,
        MatInputModule,
        MatSelectModule,
        FormsModule
    ],
})
export class DialogsModule {}
